import React from 'react'

import useQueryURL from '../../../../../common/hooks/useQueryURL'
import ModalDrawer from '../../../../../common/components/organisme/ModalDrawer/ModalDrawer'
import AddNewHardwareFromPresenter from '../../AddNewHardwareForm/AddNewHardwareFromPresenter'
import AddNewHardwareBtn from '../../AddNewHardwareBtn/AddNewHardwareBtn'

const MODAL_ID = "addNewHardwareModal"

export default function AddNewHarwarePresenter() {
  return (
      <AddNewHardwareBtn modalId={MODAL_ID}/>
  )
}

export const AddNewButtonModal = () => {
    const {removeQueryValue} = useQueryURL()
    const onSuccess = () => {
        removeQueryValue([MODAL_ID])
    }
    return (
        <>
        <AddNewHarwarePresenter/>
        <ModalDrawer urlParamName={MODAL_ID} title="Ajouter un Hardware">
        <AddNewHardwareFromPresenter  onSuccess={onSuccess}/>
        </ModalDrawer>
        </>
    )

}